import { merge, sumBy } from '@guiker/shared-framework'

import { FinancialStatements, FinancialStatementsWriteModel } from '../entity/financial-statements'

export const hydrateFinancialStatements = (
  financialStatementsDocument: FinancialStatementsWriteModel,
): FinancialStatements => {
  const { balanceSheet, shareholderEquityStatement } = financialStatementsDocument
  const totalLiabilityValues = sumBy(balanceSheet?.liabilities ?? [], 'amount') || 0
  const totalAssetValue = sumBy(balanceSheet?.assets ?? [], 'amount') || 0
  const netAssetValue = totalAssetValue - totalLiabilityValues

  return merge({}, financialStatementsDocument, {
    balanceSheet: {
      totalLiabilityValues,
      totalAssetValue,
      netAssetValue,
    },
    shareholderEquityStatement: {
      netAssetValuePerUnit: netAssetValue / (shareholderEquityStatement?.totalUnitCount || 1),
    },
  })
}
